import React from "react";

const VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/wyq2iqxk_video.mp4";

export default function VideoProcess() {
  const videoRef = React.useRef(null);

  React.useEffect(() => {
    // Ensure autoplay kicks in for iOS/Safari edge cases
    const v = videoRef.current;
    if (v) {
      v.muted = true;
      const p = v.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    }
  }, []);

  return (
    <section
      id="video-proceso"
      className="relative bg-[#141311] py-20 md:py-28 overflow-hidden"
      data-testid="video-process-section"
    >
      {/* Soft radial glow */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 30%, rgba(212,185,122,0.18) 0%, rgba(20,19,17,0) 55%)",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-[1fr_1.1fr] gap-10 md:gap-16 items-center">
          {/* Texto */}
          <div className="text-white">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#d4b97a] mb-4">
              Así nace tu retrato
            </div>
            <h2 className="font-serif font-medium text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-6">
              Cada pieza,{" "}
              <span className="italic text-[#d4b97a]">personalizada</span>
            </h2>
            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-6 max-w-md">
              Grabamos tu retrato con impresión UV de alta definición sobre un
              taco macizo de madera blanca de 20×15×3&nbsp;cm. Sin cristales, sin
              marcos — solo madera noble y tintas que duran años.
            </p>

            <ul className="space-y-2 text-sm text-white/70">
              <li className="flex items-center gap-3">
                <span className="h-1.5 w-1.5 rounded-full bg-[#d4b97a]" />
                Tintas UV resistentes a la luz y al rayado
              </li>
              <li className="flex items-center gap-3">
                <span className="h-1.5 w-1.5 rounded-full bg-[#d4b97a]" />
                Madera natural tratada, lista para colgar o exponer
              </li>
              <li className="flex items-center gap-3">
                <span className="h-1.5 w-1.5 rounded-full bg-[#d4b97a]" />
                Producción en Badajoz, España
              </li>
            </ul>
          </div>

          {/* Vídeo cuadrado */}
          <div className="relative">
            <div
              className="relative aspect-square rounded-2xl overflow-hidden ring-1 ring-white/10 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] bg-[#0f0e0c]"
              data-testid="video-process-container"
            >
              <video
                ref={videoRef}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                className="h-full w-full object-cover"
                data-testid="video-process-player"
              >
                <source src={VIDEO_URL} type="video/mp4" />
              </video>
              {/* Subtle inner vignette */}
              <div
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{
                  boxShadow: "inset 0 0 80px rgba(0,0,0,0.35)",
                }}
              />
            </div>

            {/* Caption debajo */}
            <div className="mt-5 text-center text-xs tracking-[0.25em] uppercase text-white/50">
              Del taller · 100% personalizado
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
